import { useMediaQuery, useTheme } from '@mui/material'
import { readNavigatorPhoneChrome } from './phoneChrome'

/**
 * Phone chrome. Width below `sm`, coarse/no-hover pointers, installed PWAs,
 * and iOS devices that lie about being a desktop Macintosh.
 */
export const useIsMobile = () => {
  const theme = useTheme()
  const sm = theme.breakpoints.values.sm
  const phoneDefault = readNavigatorPhoneChrome(sm)
  const narrow = useMediaQuery(theme.breakpoints.down('sm'), {
    noSsr: true,
    defaultMatches: phoneDefault,
  })
  const coarseNoHover = useMediaQuery('(hover: none) and (pointer: coarse)', {
    noSsr: true,
    defaultMatches: phoneDefault,
  })
  return narrow || coarseNoHover || phoneDefault
}
